import {
  ButtonComponent,
  ButtonSubTheme,
  ButtonTheme,
  ButtonType,
} from '@myre/ui-primitive-components';
import { TranslatePipe } from '@myre/ui-primitive-core';

import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { type Observable } from 'rxjs';

import {
  ModalSectionKey,
  type ModalFooterData,
} from '../../../modal.interface';

import { ModalSectionComponent } from '../abstract/modal-section.component';

@Component({
  selector: 'myre-modal-footer-default',
  templateUrl: './app-modal-footer-default.component.html',
  styleUrls: ['./app-modal-footer-default.component.scss'],
  imports: [ButtonComponent, TranslatePipe, AsyncPipe],
})
export class DefaultFooterComponent extends ModalSectionComponent<ModalFooterData> {
  public isLoading$: Observable<boolean>;
  protected _name = ModalSectionKey.Footer;

  public click(action: string): void {
    const clickHandler = (this._context() as Record<string, unknown>)[
      `${action}Click`
    ];

    if ('function' === typeof clickHandler) {
      return clickHandler.call(this._context());
    }
  }

  public actionLoading(): boolean {
    const loading = this.data().action?.loading;

    return Boolean(loading && loading());
  }

  public actionDisabled(): boolean {
    const disabled = this.data().action?.disabled;

    return Boolean(disabled && disabled());
  }

  public okDisabled(): boolean {
    if (this._context()?.formGroup) {
      // if form has control(s) it should have at least one element dirty & valid
      return (
        Object.keys(this._context().formGroup.controls).length &&
        !(
          this._context().formGroup &&
          this._context().formGroup.valid &&
          this._context().formGroup.dirty
        )
      );
    }

    return false;
  }

  protected readonly ButtonTheme = ButtonTheme;
  protected readonly ButtonSubTheme = ButtonSubTheme;
  protected readonly ButtonType = ButtonType;
}
